/**
 * Shared no-op function reference.
 *
 * Use as a safe default when passing to APIs that invoke a callback
 * unconditionally but where the consumer intentionally has nothing to do
 * (e.g., non-dismissible modals passing an escape/outside-click handler).
 *
 * Preferred over `() => {}` at call sites because the reference is stable
 * across renders, which avoids re-allocations and prop-identity churn.
 */
const noop = (): void => {}

export default noop
